import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { Button, Form, Spinner } from 'react-bootstrap';

const TreeVigourMonitoringForm = ({ onCancel }) => {
  const {
    values,
    errors,
    isSubmitting,
    handleSubmit,
    handleChange,
    handleBlur
  } = useFormikContext();

  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Form.Group className='mb-3' controlId='date'>
          <Form.Label>Date</Form.Label>
          <Form.Control
            type='date'
            onChange={handleChange}
            onBlur={handleBlur}
            value={(values.date || '').slice(0, 10)}
            placeholder='Select date'
            isInvalid={!!errors.date}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.date}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='terminated_percent'>
          <Form.Label>Terminated %</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.terminated_percent}
            placeholder=''
            isInvalid={!!errors.terminated_percent}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.terminated_percent}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='active_percent'>
          <Form.Label>Active %</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.active_percent}
            placeholder=''
            isInvalid={!!errors.active_percent}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.active_percent}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='none_percent'>
          <Form.Label>None %</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.none_percent}
            placeholder=''
            isInvalid={!!errors.none_percent}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.none_percent}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='shoots_infected_percent'>
          <Form.Label>Shoots Infected %</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.shoots_infected_percent}
            placeholder=''
            isInvalid={!!errors.shoots_infected_percent}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.shoots_infected_percent}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='old_damage_count'>
          <Form.Label>Old Damage #</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.old_damage_count}
            placeholder=''
            isInvalid={!!errors.old_damage_count}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.old_damage_count}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='new_damage_count'>
          <Form.Label>New Damage #</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.new_damage_count}
            placeholder=''
            isInvalid={!!errors.new_damage_count}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.new_damage_count}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='broken_damage_count'>
          <Form.Label>Broken Damage #</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.broken_damage_count}
            placeholder=''
            isInvalid={!!errors.broken_damage_count}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.broken_damage_count}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className='mb-3' controlId='leaves_per_shoot'>
          <Form.Label>Leaves/Shoot</Form.Label>
          <Form.Control
            type='number'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.leaves_per_shoot}
            placeholder=''
            isInvalid={!!errors.leaves_per_shoot}
            min={0}
          />
          <Form.Control.Feedback type='invalid'>
            {errors.leaves_per_shoot}
          </Form.Control.Feedback>
        </Form.Group>
        <Button variant='primary' type='submit'>
          {isSubmitting ? (
            <Spinner className='mx-3' animation='border' size='sm' />
          ) : (
            'Submit'
          )}
        </Button>{' '}
        <Button variant='secondary' type='button' onClick={onCancel}>
          Cancel
        </Button>
      </Form>
    </>
  );
};

export default observer(TreeVigourMonitoringForm);

